import { supabase } from '../../lib/supabase';

/**
 * Service to handle user confirmation via Supabase Edge Functions
 */
export const userConfirmationService = {
  /**
   * Confirms a user's email address using the Supabase Edge Function
   * @param userId The ID of the user to confirm
   * @returns A promise that resolves when the user is confirmed
   */
  confirmUser: async (userId: string): Promise<void> => {
    try {
      // Get the current session
      const { data: sessionData } = await supabase.auth.getSession();
      
      if (!sessionData.session) {
        throw new Error('No active session');
      }
      
      // Call the Edge Function with the user's ID
      const { data, error } = await supabase.functions.invoke('confirm-user', {
        body: { userId },
      });
      
      if (error) {
        console.error('Error confirming user:', error);
        throw new Error(`Failed to confirm user: ${error.message}`);
      }
      
      if (!data || !data.success) {
        throw new Error('Failed to confirm user');
      }
      
      console.log('User confirmed successfully:', data.message);
    } catch (error) {
      console.error('Error in confirmUser:', error);
      throw error;
    }
  },
  
  /**
   * Sets a user's password directly (requires admin privileges)
   * This is a fallback method if the Edge Function is not available
   * @param userId The ID of the user
   * @param password The new password
   * @returns A promise that resolves when the password is set
   */
  setUserPassword: async (userId: string, password: string): Promise<void> => {
    try {
      // This is a placeholder - in a real implementation, you would call another
      // Edge Function that uses the admin API to set the password
      console.warn('Setting user password directly is not implemented');
      throw new Error('Setting user password directly is not implemented');
    } catch (error) {
      console.error('Error in setUserPassword:', error);
      throw error;
    }
  }
};
